import { z } from 'zod'

export const pricingVariantSchema = z.object({
  size_category: z.object({
    id: z.number(),
    value: z.string(),
  }).optional().nullable(),
  coat_type: z.object({
    id: z.number(),
    value: z.string(),
  }).optional().nullable(),
  breed: z.object({
    id: z.string(),
    value: z.string(),
  }).optional().nullable(),
  is_default: z.boolean().optional(),
  override_type: z.enum(['breed', 'size-coat']).optional().nullable(),
  price: z.number({
    invalid_type_error: 'Price must be a valid number.',
  })
    .min(1, { message: 'Price is required.' }),
  duration: z.number({
    invalid_type_error: 'Duration must be a valid number.',
  })
    .min(1, { message: 'Duration is required.' }),
}).superRefine((variant, ctx) => {
  if (!variant.is_default) {
    const hasBreed = !!variant.breed
    const hasSizeCoat = !!(variant.size_category && variant.coat_type)

    // Breed overrides should not have size/coat
    if (hasBreed && hasSizeCoat) {
      ctx.addIssue({
        code: 'custom',
        path: ['breed'],
        message: 'Breed overrides cannot have size or coat specified.',
      })
    }

    // Non-default variants must have either breed OR size/coat
    if (!hasBreed && !hasSizeCoat) {
      if (!variant.size_category) {
        ctx.addIssue({
          code: 'custom',
          path: ['size_category'],
          message: 'Size category is required for size/coat overrides.',
        })
      }
      if (!variant.coat_type) {
        ctx.addIssue({
          code: 'custom',
          path: ['coat_type'],
          message: 'Coat type is required for size/coat overrides.',
        })
      }
      if (!variant.breed) {
        ctx.addIssue({
          code: 'custom',
          path: ['breed'],
          message: 'Either breed or size/coat must be specified for overrides.',
        })
      }
    }
  }
})

export type PricingVariantSchema = z.infer<typeof pricingVariantSchema>
